import { PageBreadcrumbs, PageHeader } from "@components";
import { QuestionEditor } from "../../components/QuestionEditor";

export function NovaPerguntaPage() {
	return (
		<div className="p-6">
			<div className="max-w-[960px]">
				<PageBreadcrumbs
					ancestors={[{ label: "Perguntas", href: "/questions/list" }]}
					current="Editor de pergunta"
				/>
				<PageHeader title="Editor de pergunta" />

				<div className="mt-6">
					<QuestionEditor />
				</div>
			</div>
		</div>
	);
}
